const $ = window.jQuery;

$(".js-remote-modal").on("hidden.bs.modal", function () {
    $(this).removeClass("is-loaded");
});
